/**
 * Wishlist service for professional plans subscription
 */

import { getBackendBaseUrl } from '../utils/configUtils';

class WishlistService {
  constructor() {
    this.baseURL = getBackendBaseUrl();
  }

  /**
   * Subscribe to professional plans wishlist
   * @param {string} email - User's email address
   * @param {string} planType - Plan type ('organizer', 'mover_pro', 'enterprise')
   * @returns {Promise<Object>} - API response
   */
  async subscribe(email, planType) {
    try {
      const response = await fetch(`${this.baseURL}/api/v2/wishlist/subscribe`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          email: email.trim().toLowerCase(),
          plan_type: planType
        })
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.error || 'Failed to subscribe to wishlist');
      }

      return {
        success: true,
        message: data.message,
        subscription: data.subscription
      };
    } catch (error) {
      console.error('Wishlist subscribe error:', error);
      return {
        success: false,
        error: error.message
      };
    }
  }

  /**
   * Unsubscribe from professional plans wishlist
   * @param {string} email - User's email address
   * @param {string} planType - Plan type ('organizer', 'mover_pro', 'enterprise')
   * @returns {Promise<Object>} - API response
   */
  async unsubscribe(email, planType) {
    try {
      const response = await fetch(`${this.baseURL}/api/v2/wishlist/unsubscribe`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          email: email.trim().toLowerCase(),
          plan_type: planType
        })
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.error || 'Failed to unsubscribe from wishlist');
      }

      return {
        success: true,
        message: data.message
      };
    } catch (error) {
      console.error('Wishlist unsubscribe error:', error);
      return {
        success: false,
        error: error.message
      };
    }
  }
}

// Export singleton instance
export default new WishlistService();
